import React from "react";
import { DocumentSignerSignatureExt } from "@newComponents/common/Viewer/types";
import { DocumentMarker } from "@newHooks/context/document/documentMarker.context";
import { AddressMarker } from "./AddressMarker";
import { CheckBoxMarker } from "./CheckBoxMarker";
import { CommonMarker } from "./CommonMarker";
import { DatePickerMarker } from "./DatePickerMarker";
import { DropdownMarker } from "./DropdownMarker";
import { FollowWritingMarker } from "./FollowWritingMarker";
import { SignMarker } from "./SignMarker";
import { StampApiMarker } from "./StampApitMarker";
import { TextFieldMarker } from "./TextFieldMarker";
import { DocumentSignerAttrType, DocumentSignType } from "@maven-rest/docs/DocumentSign.dto";

export interface EConsentMarkerProps {
  id: string;
  key: string;
  left: string;
  top: string;
  isModeLinking: boolean;
  isModeSigning: boolean;
  isModeSigner: boolean;
  isReadonly: boolean;
  isHidden: boolean;
  marker: DocumentMarker;
  signType?: DocumentSignType;
  signatures?: DocumentSignerSignatureExt[];
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  children?: React.ReactNode;
  onMouseDown: (e: React.DragEvent<HTMLDivElement>) => void;
  resizeMode: boolean;
}

export function EConsentMarker(props: EConsentMarkerProps): JSX.Element {
  switch (props.marker.attr) {
    case DocumentSignerAttrType.StampApiMark:
      return StampApiMarker(props);

    case DocumentSignerAttrType.AgentAvailableMark:
    case DocumentSignerAttrType.ResponsiveItemFieldMark:
    case DocumentSignerAttrType.AgentResponsiveItemFieldMark:
      return CheckBoxMarker(props);

    case DocumentSignerAttrType.InputItemMark:
    case DocumentSignerAttrType.AgentInputItemMark:
      return TextFieldMarker(props);

    case DocumentSignerAttrType.DropdownItemMark:
    case DocumentSignerAttrType.AgentDropdownItemMark:
      return DropdownMarker(props);

    case DocumentSignerAttrType.DateItemMark:
    case DocumentSignerAttrType.AgentDateItemMark:
      return DatePickerMarker(props);

    case DocumentSignerAttrType.AddressItemMark:
    case DocumentSignerAttrType.AgentAddressItemMark:
      return AddressMarker(props);

    case DocumentSignerAttrType.FollowWritingItemMark:
    case DocumentSignerAttrType.AgentFollowWritingItemMark:
      return FollowWritingMarker(props);

    case DocumentSignerAttrType.Sign:
    case DocumentSignerAttrType.Signature:
    case DocumentSignerAttrType.AgentSignature:
      return SignMarker(props);

    default:
      return CommonMarker(props);
  }
}
